<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Mesin Presensi</span>
		</div>
		<div class="card-body">
			<div class="text-end mb-3">
				<el-button type="info" icon="Plus" plain round @click="dialogCreateVisible = true">Tambah data</el-button>
			</div>
			<el-form :model="formEdit" @submit.prevent="updateData" :rules="rulesEdit" ref="formEdit" inline-message>
				<el-table
					:data="mesinPresensi"
					table-layout="auto"
					border
					stripe
					v-loading="loading"
					:header-cell-style="{ background: 'var(--el-fill-color-light)' }"
					class="shadow-sm"
					:cell-class-name="cellClass">
					<template #empty>
						<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
					</template>
					<el-table-column type="index" label="No." align="center" />
					<el-table-column label="Nama Mesin" prop="nama" align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-form-item prop="nama" v-if="rowEditing === row" class="mb-0">
									<el-input v-model="formEdit.nama" :placeholder="row.nama" clearable style="min-width: 120px" />
								</el-form-item>
								<span v-else :key="row.nama" class="text-nowrap">{{ row.nama }}</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Cloud ID" prop="cloud_id" align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-form-item prop="cloud_id" v-if="rowEditing === row" class="mb-0">
									<el-input v-model="formEdit.cloud_id" :placeholder="row.cloud_id" clearable style="min-width: 170px" />
								</el-form-item>
								<span v-else :key="row.cloud_id">{{ row.cloud_id }}</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Nomor Seri" prop="nomor_seri" align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-form-item prop="nomor_seri" v-if="rowEditing === row" class="mb-0">
									<el-input v-model="formEdit.nomor_seri" :placeholder="row.nomor_seri" clearable style="min-width: 150px" />
								</el-form-item>
								<span v-else :key="row.nomor_seri">{{ row.nomor_seri }}</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Keterangan" prop="keterangan" header-align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-form-item prop="keterangan" v-if="rowEditing === row" class="mb-0">
									<el-input v-model="formEdit.keterangan" :placeholder="row.keterangan" clearable style="min-width: 170px" />
								</el-form-item>
								<span v-else :key="row.keterangan">{{ row.keterangan }}</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Status" prop="aktif" align="center" sortable>
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-form-item prop="aktif" v-if="rowEditing === row" class="mb-0">
									<el-switch v-model="formEdit.aktif" inline-prompt active-text="Aktif" inactive-text="Tidak Aktif" />
								</el-form-item>
								<div class="hstack gap-1 justify-content-between" v-else :key="row.aktif">
									{{ row.aktif ? "Aktif" : "Tidak aktif" }}
									<el-tooltip>
										<template #content>
											Dibuat: <em>{{ row.created_at }}</em>
											<br />
											Diperbarui: <em>{{ row.updated_at || "-" }}</em>
										</template>
										<el-icon><i class="bi bi-info-circle"></i></el-icon>
									</el-tooltip>
								</div>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="Tindakan" align="center">
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<el-space :spacer="spacer" :size="0" v-if="rowEditing === row">
									<el-button type="info" size="small" plain round @click="rowEditing = null">Batal</el-button>
									<el-button type="success" size="small" round native-type="submit" :loading="updating">Simpan</el-button>
								</el-space>
								<el-space :spacer="spacer" :size="0" v-else>
									<el-tooltip content="Edit data">
										<el-button type="primary" size="small" icon="Edit" plain round @click="rowEditing = row" />
									</el-tooltip>
									<el-tooltip content="Hapus data">
										<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
									</el-tooltip>
								</el-space>
							</transition>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
		</div>

		<el-form
			:model="formCreate"
			:rules="rulesCreate"
			ref="formCreate"
			label-width="auto"
			label-position="top"
			require-asterisk-position="right"
			@submit.prevent="insertData"
			:disabled="inserting">
			<el-dialog v-model="dialogCreateVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Tambah Data Mesin Presensi" align-center :width="modalWidth">
				<el-row :gutter="10">
					<el-col :xs="24" :sm="12">
						<el-form-item label="Nama Mesin" prop="mesin_presensi_id">
							<el-input v-model="formCreate.nama" placeholder="Nama mesin" />
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12">
						<el-form-item label="Cloud ID" prop="cloud_id">
							<el-input v-model="formCreate.cloud_id" placeholder="Identitas unik mesin" clearable />
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12">
						<el-form-item label="Nomor Seri" prop="nomor_seri">
							<el-input v-model="formCreate.nomor_seri" placeholder="Nomor seri mesin" clearable />
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12">
						<el-form-item label="Keterangan" prop="keterangan">
							<el-input v-model="formCreate.keterangan" placeholder="Keterangan" clearable />
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12">
						<el-form-item label="Status" prop="aktif">
							<el-switch v-model="formCreate.aktif" inline-prompt active-text="Aktif" inactive-text="Tidak Aktif" />
						</el-form-item>
					</el-col>
				</el-row>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "MesinView",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			mesinPresensi: [],
			loading: true,
			modalWidth: "50%",
			dialogCreateVisible: false,
			formCreate: {
				cloud_id: null,
				nomor_seri: null,
				nama: null,
				keterangan: null,
				aktif: true,
			},
			formEdit: {
				cloud_id: null,
				nomor_seri: null,
				nama: null,
				keterangan: null,
				aktif: false,
			},
			rowEditing: null,
			rulesCreate: {
				cloud_id: [
					{ required: true, message: "Cloud ID harus diisi", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const exists = this.mesinPresensi.some((m) => m.cloud_id === value);
							if (!value) {
								callback(new Error("Cloud ID harus diisi"));
							} else if (exists) {
								callback(new Error("Cloud ID sudah ada!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				nomor_seri: [
					{ required: true, message: "Nomor seri mesin harus diisi", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const exists = this.mesinPresensi.some((m) => m.nomor_seri === value);
							if (!value) {
								callback(new Error("Nomor seri mesin harus diisi"));
							} else if (exists) {
								callback(new Error("Nomor seri sudah ada!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				nama: [{ required: true, message: "Nama mesin harus diisi", trigger: "change" }],
				keterangan: [{ required: true, message: "Keterangan harus diisi", trigger: "change" }],
			},
			rulesEdit: {
				cloud_id: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const exists = this.mesinPresensi.some((m) => m.cloud_id === value);
							if (!value) {
								callback();
							} else if (exists) {
								callback(new Error("Cloud ID sudah ada!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				nomor_seri: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: (rule, value, callback) => {
							const exists = this.mesinPresensi.some((m) => m.nomor_seri === value);
							if (!value) {
								callback();
							} else if (exists) {
								callback(new Error("Nomor seri sudah ada!"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
			},
			inserting: false,
			updating: false,
			deleting: false,
		};
	},
	computed: {
		formChanged() {
			if (this.rowEditing) {
				const payload = Object.fromEntries(
					Object.entries(this.formEdit).filter(([key, value]) => {
						const isChanged = value !== this.rowEditing[key];
						const isNotEmpty = value !== "" && value !== null && value !== undefined;

						return isChanged && isNotEmpty;
					}),
				);

				return Object.keys(payload).length > 0;
			}

			return false;
		},
	},
	watch: {
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
		},
		rowEditing(row) {
			this.$refs.formEdit.resetFields();
			if (row) {
				this.formEdit.aktif = row.aktif;
			}
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.on("mesin:inserted", this.insertedMesinPresensi);
		this.$ws.main.on("mesin:updated", this.updatedMesinPresensi);
		this.$ws.main.on("mesin:deleted", this.deletedMesinPresensi);

		new Promise((resolve) => {
			setTimeout(async () => {
				await this.getMesinPresensi();
				resolve();
			}, 500);
		}).then(() => {
			this.loading = false;
		});
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.off("mesin:inserted");
		this.$ws.main.off("mesin:updated");
		this.$ws.main.off("mesin:deleted");
	},
	beforeRouteLeave(to, from, next) {
		if (this.formChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		insertedMesinPresensi(data) {
			const tmp = data;
			tmp.aktif = data.aktif === 1;
			tmp.created_at = new Date(data.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });

			this.mesinPresensi.push({
				...data,
				created_at: new Date(data.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
			});
		},
		updatedMesinPresensi(data) {
			const index = this.mesinPresensi.findIndex((m) => m.mesin_presensi_id === data.mesin_presensi_id);

			if (index !== -1) {
				this.mesinPresensi[index] = {
					...data,
					aktif: data.aktif === 1,
					created_at: new Date(data.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					updated_at: new Date(data.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
				};

				if (this.rowEditing && Number(this.rowEditing.mesin_presensi_id) === Number(data.mesin_presensi_id) && typeof data.aktif === "number") {
					this.formEdit.aktif = data.aktif === 1;
				}
			}
		},
		deletedMesinPresensi(data) {
			const index = this.mesinPresensi.findIndex((m) => m.mesin_presensi_id === data.mesin_presensi_id);

			if (index !== -1) this.mesinPresensi.splice(index, 1);
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "90%";
			else if (w < 768) this.modalWidth = "80%";
			else if (w < 992) this.modalWidth = "70%";
			else if (w < 1200) this.modalWidth = "55%";
			else if (w < 1500) this.modalWidth = "40%";
			else if (w < 1920) this.modalWidth = "35%";
			else this.modalWidth = "30%";
		},
		handleBeforeUnload(e) {
			if (this.formChanged) {
				e.preventDefault();
				e.returnValue = "";
				return "";
			}
		},
		cellClass({ row }) {
			if (this.rowEditing === row) {
				return "align-top";
			}
			return "";
		},
		async getMesinPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/mesin/index", {});

				const result = data.data.mesin_presensi;

				result.forEach((r) => {
					r.aktif = r.aktif === 1;
					r.created_at = new Date(r.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" });
					r.updated_at = r.updated_at ? new Date(r.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }) : null;
				});

				this.mesinPresensi = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async insertData() {
			this.inserting = true;

			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/mesin", this.formCreate);

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateData() {
			this.updating = true;

			const payload = Object.fromEntries(
				Object.entries(this.formEdit).filter(([key, value]) => {
					const isChanged = value !== this.rowEditing[key];
					const isNotEmpty = value !== "" && value !== null && value !== undefined;

					return isChanged && isNotEmpty;
				}),
			);

			try {
				if (!this.formChanged) {
					throw Error("Belum ada perubahan");
				}

				const valid = await this.$refs.formEdit.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.patch(`/mesin/${this.rowEditing.mesin_presensi_id}`, payload);

				this.rowEditing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, ["Anda yakin ingin menghapus ", h("mark", { class: "fw-bold" }, row.nama), "?"]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteData(row))
				.catch(() => {});
		},
		async deleteData(row) {
			this.deleting = row;
			try {
				const { data } = await this.$defaultApi.delete(`/mesin/${row.mesin_presensi_id}`);

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = null;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
